export const secrets = {
  MoralisApiKey: process.env.MORALIS_API_KEY || '',
  MoralisStreamSecret: process.env.MORALIS_STREAM_SECRET || '',
  env: process.env.NEXT_PUBLIC_ENV || 'development',
  reownProjectId: process.env.NEXT_PUBLIC_PROJECT_ID || '',
  privateKeyExecutor: process.env.PRIVATE_KEY_EXECUTOR || '',
  savingsFrom: process.env.SAVINGS_FROM_ADDRESS || '',
  alchemyApiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY || '',
  MoralisStreamIdEoaTransferArcTestnet: process.env.MORALIS_STREAM_ID_EOA_TRANSFER_ARC_TESTNET || '',
  MoralisStreamIdEoaTransferBase: process.env.MORALIS_STREAM_ID_EOA_TRANSFER_BASE || '',
  MoralisStreamIdEoaTransferLinea: process.env.MORALIS_STREAM_ID_EOA_TRANSFER_LINEA || '',
  MoralisStreamIdEoaTransferSepolia: process.env.MORALIS_STREAM_ID_EOA_TRANSFER_SEPOLIA || '',
  MoralisStreamIdMmcWithdrawalArcTestnet: process.env.MORALIS_STREAM_ID_MMC_WITHDRAWAL_ARC_TESTNET || '',
  MoralisStreamIdMmcWithdrawalBase: process.env.MORALIS_STREAM_ID_MMC_WITHDRAWAL_BASE || '',
  MoralisStreamIdMmcWithdrawalLinea: process.env.MORALIS_STREAM_ID_MMC_WITHDRAWAL_LINEA || '',
  MoralisStreamIdMmcWithdrawalSepolia: process.env.MORALIS_STREAM_ID_MMC_WITHDRAWAL_SEPOLIA || '',
  rudderstackWriteKey: process.env.RUDDERSTACK_WRITE_KEY || '',
  rudderstackDataPlaneUrl: process.env.RUDDERSTACK_DATAPLANE_URL || '',
};
